export default "__VITE_PUBLIC_ASSET__35ff2ce8__"